<template>
  <div>
    <Dialog
      :id="'dialogSelectUsuario'"
      ref="dialogSelectUsuario"
      :hide-header="false"
      :hideFooter="true"
      :modal="true"
      :tamanho="'md'"
      :classModalBody="'mx-5 mx-xl-1 my-1'"
      :titulo="'Usuários'"
      @dialog-off="fechar()"
    >
      <UsuarioSelect
        ref="usuarioSelect"
        :dialog="true"
        @selecionar="selecionar()"
      />
    </Dialog>
  </div>
</template>

<script>
import UsuarioSelect from "./UsuarioSelect.vue";
import Dialog from "../components/ComponentDialog.vue";

export default {
  components: { UsuarioSelect, Dialog },
  props: {},

  data() {
    return {
      filtroNuvem: "",
      filtroCliente: "",
    };
  },

  mounted() {},

  methods: {
    abrir(itensSelecionadosPadrao = {}) {
      this.filtroNuvem = "";
      this.filtroCliente = "";
      this.$refs.usuarioSelect.filtroTexto = "";
      this.$refs.usuarioSelect.itensSelecionados = {};
      this.$refs.usuarioSelect.itensSelecionadosPadrao =
        itensSelecionadosPadrao;
      this.$refs.usuarioSelect.filtroCliente = this.filtroCliente;
      this.$refs.usuarioSelect.filtroNuvem = this.filtroNuvem;
      this.$refs.usuarioSelect.carregarItens();
      this.$refs.dialogSelectUsuario.abrir();
    },
    abrirCliente(cliente, itensSelecionadosPadrao = {}) {
      this.filtroNuvem = "";
      this.filtroCliente = cliente;
      this.$refs.usuarioSelect.filtroTexto = "";
      this.$refs.usuarioSelect.itensSelecionados = {};
      this.$refs.usuarioSelect.itensSelecionadosPadrao =
        itensSelecionadosPadrao;
      this.$refs.usuarioSelect.filtroCliente = this.filtroCliente;
      this.$refs.usuarioSelect.filtroNuvem = this.filtroNuvem;
      this.$refs.usuarioSelect.carregarItens();
      this.$refs.dialogSelectUsuario.abrir();
    },
    abrirNuvem(nuvem, itensSelecionadosPadrao = {}) {
      this.filtroNuvem = nuvem;
      this.filtroCliente = "";
      this.$refs.usuarioSelect.filtroTexto = "";
      this.$refs.usuarioSelect.itensSelecionados = {};
      this.$refs.usuarioSelect.itensSelecionadosPadrao =
        itensSelecionadosPadrao;
      this.$refs.usuarioSelect.filtroCliente = this.filtroCliente;
      this.$refs.usuarioSelect.filtroNuvem = this.filtroNuvem;
      this.$refs.usuarioSelect.carregarItens();
      this.$refs.dialogSelectUsuario.abrir();
    },
    selecionar() {
      this.$refs.dialogSelectUsuario.fechar();
      this.$emit("selecionar", this.$refs.usuarioSelect.itensSelecionados);
    },
    fechar() {
      this.$emit("cancelar");
    },
  },
};
</script>

<style>
</style>
